<div class="alert-box" [ngStyle]="!isMobile && {'width.%': 60, 'margin': 'auto', 'padding': '5% 10%'}">
  <div class="icon-wrapper"><mat-icon [svgIcon]="'important'"></mat-icon></div>
  <p class="content text-center mt-2">{{ content }}</p>

  <div class="payment-modal-buttons-container row justify-content-center">
    <div class="col-6 w-auto">
      <button (click)="onGoToPay(false)" class="payment-modal-button cancel-button btn mt-2">
        {{ "premiumServices.cancel" | translate }}
      </button>
    </div>
    <div class="col-6 w-auto">
      <button (click)="onGoToPay(true)" class="payment-modal-button pay-button btn btn-primary mt-2">
        {{ "premiumServices.goToPay" | translate }}
      </button>
    </div>
  </div>
</div>

